// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Stop = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
      strokeLinecap='round'
    >
      <rect stroke={stroke} fill={fill} x='1' y='1' width='46' height='46' />
    </svg>
  );
};
